import type { ReactNode } from 'react';
import { ImageComponent } from '@/components/Image';
import type { IComparisonUICell } from '@/modules/vip/ComparisonSection/types';

type CellType = 'image' | 'text' | 'empty';

const resolveCellType = (cell: IComparisonUICell): CellType => {
  if (cell.imgUrl) return 'image';
  if (cell.text) return 'text';
  return 'empty';
};

const CELL_RENDERERS: Record<CellType, (cell: IComparisonUICell) => ReactNode> =
  {
    image: (cell) =>
      cell.imgUrl && (
        <ImageComponent alt="" height={24} src={cell.imgUrl} width={24} />
      ),
    text: (cell) => cell.text,
    empty: () => '—',
  };

export const CellContent = ({ cell }: { cell: IComparisonUICell }) =>
  CELL_RENDERERS[resolveCellType(cell)](cell);
